export class PriceUploadExcelViewModel {
    areaCode: string;
    WeightCode:string;
    price: number;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/view-model/priceUploadExcel.viewModel.ts